var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.clientId!=='')?_c('XTerm',{attrs:{"terminal":_vm.terminal,"client-id":_vm.clientId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }